import React, { useEffect, useState } from 'react';

/**
 * HeroScrollFade — a fixed, film-like dark scrim pinned to the BOTTOM of the
 * viewport. It stays put while you scroll (cinematic letterbox feel) and fades
 * OUT as you approach the bottom of the page, so it never covers the footer.
 */
const FADE_ZONE = 260; // px from the page bottom over which the scrim fades out

const HeroScrollFade = () => {
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    let raf = 0;
    const update = () => {
      raf = 0;
      const doc = document.documentElement;
      const distFromBottom = doc.scrollHeight - (window.scrollY + window.innerHeight);
      const o = Math.max(0, Math.min(1, distFromBottom / FADE_ZONE));
      setOpacity(o);
    };
    const onScroll = () => {
      if (!raf) raf = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) window.cancelAnimationFrame(raf);
    };
  }, []);

  return <div className="hero-scroll-fade" aria-hidden="true" style={{ opacity }} />;
};

export default HeroScrollFade;
